import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import type { RhsRecord } from 'uplisting-frontend/utils/rhs/types';
import { getRhsRecordKey } from 'uplisting-frontend/utils/rhs/helpers';

export default class ContextualReplyRepositoryService extends BaseRepositoryService<
  ModelRegistry['contextual-reply']
> {
  recordName = 'contextual-reply';
  implementMethods = ['findRecord', 'unloadAll'];

  public async find(id: string, record: RhsRecord) {
    return super.findRecord(id, {
      adapterOptions: {
        reference_id: record.id,
        reference_type: getRhsRecordKey(record),
      },
    });
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/contextual-reply': ContextualReplyRepositoryService;
  }
}
